import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ArticleV1, NewArticleV1 } from '@ilteducation/content-registry-types';

type Props = {
  id?: string;
  title: string;
  item: ArticleV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item: ArticleV1;
}


console.log(props.item);

return { __sfc: true,props }
}

})